import { DataTypeEmpty } from 'features/modular-workflow/builder/settings/DataTypeEmpty';

export const DataTypeInformationCollection = () => <DataTypeEmpty />;
